import { ControlledSwitch } from '@@viewCommonComponents/controlled';

const GuaranteeOptionSwitch = ({
  guarantee,
  code,
  configKey,
  labelKey,
  infoKey,
  form,
  getMiddleText,
  getMiddleBoolean,
  extraClick,
  rules
}) => {
  if (!guarantee || !getMiddleBoolean(configKey)) return null;

  return (
    <ControlledSwitch
      name={`guarantees.${code}.selected`}
      label={getMiddleText(labelKey)}
      containerClassName="mb-2"
      labelClassNames="text-lg"
      disabled={!guarantee.editable}
      form={form}
      displayError={false}
      recommended={guarantee.recommended}
      infoMessage={getMiddleText(infoKey)}
      data-testid={code}
      extraClick={extraClick}
      rules={rules}
    />
  );
};

export default GuaranteeOptionSwitch;
